import { render } from "./TabbedSlide.vue?vue&type=template&id=e75f60ac&ts=true"
import script from "./TabbedSlide.vue?vue&type=script&lang=ts"
export * from "./TabbedSlide.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__